import keyMirror from 'keymirror';

const NotificationsConstants = keyMirror({
  NOTIFICATION_CLOSED: null,
  NOTIFICATION_ADDED: null,
});

export default NotificationsConstants;
